import { cloneDeep } from "lodash";
import { ServiceInsightsPhotoObject } from "../../types/service-insights-export-photo.types";

// Fixed syntax for object definition
export const ServiceInsightsphotoObjectDefault: ServiceInsightsPhotoObject = cloneDeep({
    photoInfo: [{
        id: 0,
        url: '',
        name: '',
        description: '',
        selected: false,
    }],
    shippingCity: '',
    shippingState: '',
    accountName: '',
    endDate: '',
    ecolabRep: '',
    photoCardFooter: '',
});

export const ServiceInsightsPhotoObjTestData: ServiceInsightsPhotoObject =
{
    "photoInfo": [
        {
            "id": 0,
            "url": "https://dummyurl.com/NA/06_2024/renditionDownload%3Frendition%3DORIGINAL_Jpg%26versionId%3D068QQ000009Kkr9?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-07-01T06:11:34Z&st=2023-11-05T23:11:34Z&spr=https,http&sig=olNK5ZQ%2BlDE3WJGZNM1khXVrg7rRbGRPMycsshJYdhM%3D",
            "description": "Terry Wilson at AMERICINN SOUTH LINCOLN",
            "name": "photoName",
            "selected": false,
        },
        {
            "id": 1,
            "url": "https://dummyurl.com/NA/06_2024/renditionDownload%3Frendition%3DORIGINAL_Jpg%26versionId%3D068QQ000009Kbfs?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-07-01T06:11:34Z&st=2023-11-05T23:11:34Z&spr=https,http&sig=olNK5ZQ%2BlDE3WJGZNM1khXVrg7rRbGRPMycsshJYdhM%3D",
            "description": "Terry Wilson at AMERICINN SOUTH LINCOLN",
            "name": "photoName",
            "selected": false
        },
        {
            "id": 2,
            "url": "https://dummyurl.com/NA/06_2024/renditionDownload%3Frendition%3DORIGINAL_Jpg%26versionId%3D068QQ000009KZB6?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-07-01T06:11:34Z&st=2023-11-05T23:11:34Z&spr=https,http&sig=olNK5ZQ%2BlDE3WJGZNM1khXVrg7rRbGRPMycsshJYdhM%3D",
            "description": "Terry Wilson at AMERICINN SOUTH LINCOLN",
            "name": "photoName",
            "selected": false
        },
        {
            "id": 3,
            "url": "https://dummyurl.com/NA/06_2024/renditionDownload%3Frendition%3DORIGINAL_Jpg%26versionId%3D068QQ000009KPDJ?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-07-01T06:11:34Z&st=2023-11-05T23:11:34Z&spr=https,http&sig=olNK5ZQ%2BlDE3WJGZNM1khXVrg7rRbGRPMycsshJYdhM%3D",
            "description": "Terry Wilson at AMERICINN SOUTH LINCOLN",
            "name": "photoName",
            "selected": false
        }
    ],
    "shippingCity": "LAKE CHARLES",
    "shippingState": "LA",
    "accountName": "SPRINGHILL SUITES",
    "endDate": "2024-06-19T17:44:06+00:00",
    "ecolabRep": "Scotty Doucet",
    "photoCardFooter": "June 19, 2024 | Scotty Doucet/SPRINGHILL SUITES",
    "workOrderId": "workOrderId"
}

